<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  mounted() {
    if (!('ontouchstart' in document.documentElement)) {
      document.documentElement.className += 'no-touch';
    }
  },
};
</script>

<style>
#app {
  font-family: sans-serif, Arial, Helvetica;
  font-size: 17px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
